<template>
  <div class="tab-pane fade in active">
    <div class="drive">
      <div class="lists">
        <div class="list-header">
          <div
            class="item-header"
            :class="'item-' + head.class + '-header'"
            v-for="head in headers"
            :key="head.title"
            @click="sortGroup(head.id)"
          >
            <div class="file-icon" v-show="head.class === 'groupname'">
              <i class="fa fa-file-o"></i>
            </div>
            <p>{{ head.title }}</p>
            <span
              class="sort"
              :class="head.sort"
              v-show="head.sort && head.showSort"
            ></span>
          </div>
        </div>
        <div class="list-content">
          <div
            class="itemlist"
            v-for="group in groups"
            :key="group.group_number"
          >
            <div class="item-groupname">
              <div class="file-icon">
                <img :src="group.group_logo" />
              </div>
              <p>
                <a @click="goToGroup(group)" :title="group.group_name">{{
                  group.group_name
                }}</a>
              </p>
              <i
                class="item-groupname-icon"
                :title="group.group_member_identity | identityNameFilter"
              >
                <svg aria-hidden="true" class="icon">
                  <use
                    xlink:href="#icon-qunzhu"
                    v-show="group.group_member_identity === 'owner'"
                  />
                  <!-- <use
                    xlink:href="#icon-guanliyuan"
                    v-show="group.group_member_identity === 'admin'"
                  /> -->
                </svg>
              </i>
              <span class="helpbox" v-if="group.group_is_review === 'wait'">
                <i class="iconfont icon-group-question color-blue"></i>
                <div class="help">
                  {{
                    "该群组处于待审核状态，创建时间：" +
                    group.group_created_date
                  }}
                </div>
              </span>
              <span class="helpbox" v-if="group.group_is_review === 'refuse'">
                <i class="iconfont icon-group-info color-red"></i>
                <div class="help">
                  {{
                    "该群组审核未通过，原因：" + group.group_review_description
                  }}
                </div>
              </span>
            </div>
            <div class="item-groupid">
              <a @click="goToGroup(group)">{{ group.group_number }}</a>
            </div>
            <div class="item-groupuser">
              <a @click="goToGroup(group, 'groupMember')">{{
                group.group_memeber_count
              }}</a>
            </div>
            <!-- <div class="item-groupfile">
              <a @click="goToGroupCloud(group, 'groupdisk-file')">{{
                group.group_file_count
              }}</a>
            </div> -->
            <div class="item-groupshare">
              <a @click="goToGroupCloud(group, 'groupdisk-share')">{{
                group.group_share_file_count
              }}</a>
            </div>
            <div class="item-groupmenu" v-show="isShowMenu(group)">
              <div class="dropdown">
                <a
                  aria-expanded="true"
                  aria-haspopup="true"
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                  id="dropdownMenu2"
                >
                  <i class="iconfont icon-more" title="更多"></i>
                </a>
                <ul
                  aria-labelledby="dropdownMenu2"
                  class="dropdown-menu dropdown-menu-right"
                >
                  <li
                    v-if="right__groupCancel && group.group_member_identity === 'owner'"
                    @click="groupCancel(group)"
                  >
                    <a>
                      <i class="ti-na"></i>
                      {{
                        group.group_is_review === "adopt"
                          ? "解散群组"
                          : "删除群组"
                      }}
                    </a>
                  </li>
                  <li
                    v-if="group.group_member_identity != 'owner'"
                    @click="groupQuit(group.group_number)"
                  >
                    <a>
                      <i class="ti-layout-sidebar-left"></i>
                      退出群组
                    </a>
                  </li>
                  <!-- <li
                    v-if="
                      right__group && isEditGroup(group) && group.group_is_review != 'refuse'
                    "
                    @click="handleEditGroup(group)"
                  >
                    <a>
                      <i class="ti-pencil"></i>
                      编辑群组信息
                    </a>
                  </li> -->
                  <!-- <li
                    v-if="
                      right__group_home_content && (isEditGroup(group) && group.group_is_review === 'adopt')
                    "
                    @click="goToGroupHome(group.group_number)"
                  >
                    <a>
                      <i class="ti-settings"></i>
                      群组主页设置
                    </a>
                  </li> -->
                  <!-- <li
                    @click="invite(group)"
                    v-if="group.group_is_review === 'adopt'"
                  >
                    <a>
                      <i class="glyphicon glyphicon-send"></i>
                      邀请入群
                    </a>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
          <div class="loadingbox" v-show="loading">
            <section class="loading Animation1">
              <section class="shape shape-1"></section>
              <section class="shape shape-2"></section>
              <section class="shape shape-3"></section>
              <section class="shape shape-4"></section>
            </section>
            <h4>正在加载，请稍后……</h4>
          </div>
          <div class="nofile nofile-padding" v-if="nothing">
            <div class="pic">
              <img src="@/assets/images/nogrouplist.svg" />
            </div>
            <h4>还没创建或加入任何群组</h4>
            <p>通过群组，可以快速通过群盘共享与管理团队文档，进行话题讨论。</p>
            <div class="nobtn">
              <button
                v-if="right__group"
                class="btn btn-default"
                type="button"
                @click="createGroup"
              >
                <i class="iconfont icon-newgroup"></i>
                创建群组
              </button>
              <button class="btn btn-default" type="button" @click="addGroup" v-if="right__groupApply">
                <i class="iconfont icon-group-plus"></i>
                加入群组
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <GroupCreate
      @groupCreated="groupRefresh"
      v-if="status.GroupCreateStatus"
    ></GroupCreate>
    <GroupAdd v-if="status.GroupAddStatus"></GroupAdd>
    <GroupEdit
      :group="group"
      @groupCreated="groupRefresh"
      v-if="status.GroupEditStatus"
    ></GroupEdit>
  </div>
</template>

<script>
import {
  getGroups,
  groupCancel,
  groupMember,
  getGroupInfo,
} from "@/api/group/group";
export default {
  name: "GroupLister",
  components: {
    GroupCreate: () => import("./GroupCreate"),
    GroupAdd: () => import("./GroupAdd"),
    GroupEdit: () => import("./GroupEdit"),
  },
  data() {
    return {
      status: {
        GroupCreateStatus: false,
        GroupAddStatus: false,
        GroupEditStatus: false,
      },
      loading: false,
      nothing: false,
      group: {},
      sortBy: {},
      headers: [
        {
          id: 1,
          title: "群名称",
          class: "groupname",
          sort: "asc",
          showSort: true,
          field: "group_name",
        },
        {
          id: 2,
          title: "群号",
          class: "groupid",
          sort: "des",
          showSort: false,
          field: "group_number",
        },
        {
          id: 3,
          title: "成员",
          class: "groupuser",
          sort: "des",
          showSort: false,
          field: "group_memeber_count",
        },
        // {
        //   id: 4,
        //   title: "文件",
        //   class: "groupfile",
        //   sort: "des",
        //   showSort: false,
        //   field: "group_file_count",
        // },
        {
          id: 5,
          title: "分享",
          class: "groupshare",
          sort: "des",
          showSort: false,
          field: "group_share_file_count",
        },
        { id: 6, title: "操作", class: "groupmenu", sort: "", showSort: false },
      ],
    };
  },
  created() {
    this.sortBy = this.headers[0];
    this.getGroups();
  },
  computed: {
    right__group_home_content () {
      return this.$store.getters.right__group_home_content
    },
    right__groupApply () {
      return this.$store.getters.right__groupApply
    },
    right__groupCancel () {
      return this.$store.getters.right__groupCancel
    },
    right__group () {
      return this.$store.getters.right__group
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
  },
  watch: {
    $route() {
      this.getGroups();
    },
  },
  filters: {
    identityNameFilter: function (value) {
      let iden;
      switch (value) {
        case "owner":
          iden = "群主";
          break;
        case "admin":
          iden = "管理员";
          break;
        case "user":
          iden = "成员";
          break;
        default:
          break;
      }
      return iden;
    },
  },
  methods: {
    createGroup() {
      $("#newgroup").modal("show");
    },
    addGroup() {
      $("#addgroup").modal("show");
    },
    invite(group) {
      let routeUrl = this.$router.resolve({
        name: "group",
        params: { groupNumber: group.group_number },
      });
      this.$confirm({
        showYesBtn: false,
        showCopyBtn: true,
        copyBtnText: "复制文字",
        title: "邀请入群",
        type: "confirm",
        content: `打开链接进入群组主页即可申请加入群组：${group.group_name}，群组主页链接：${window.location.origin}${routeUrl.href}`,
      })
        .then(() => {})
        .catch(() => {});
    },
    goToGroupCloud(group, tab) {
      if (["owner", "admin", "user"].indexOf(group.group_member_identity) < 0) {
        this.$message({
          type: "warning",
          message: "您不是组群成员，无法进入群盘",
        });
        return false;
      }
      this.$store.commit("setSetting", {
        from: true,
        drive: "groupdisk",
        tab: tab,
        group: group,
      });
      this.$router.push({
        name: "groupDisk",
        params: { groupNumber: group.group_number },
      });
    },
    isShowMenu(group) {
      return (
        ["owner", "admin", "user"].indexOf(group.group_member_identity) > -1
      );
    },
    isEditGroup(group) {
      return ["owner", "admin"].indexOf(group.group_member_identity) > -1;
    },
    goToGroup(group, name = "group") {
      if (group.group_is_review === "wait") {
        this.$message({
          type: "warning",
          message: "群组待审核，不允许操作！",
        });
        return false;
      } else if (group.group_is_review === "refuse") {
        this.$message({
          type: "warning",
          message: "群组审核未通过，不允许操作！",
        });
        return false;
      }
      let routeUrl = this.$router.resolve({
        name: name,
        params: { groupNumber: group.group_number },
      });
      window.open(routeUrl.href, "_blank");
    },
    goToGroupHome(groupNumber) {
      this.$store.commit("SET_GROUP_SHOWDESC", false);
      this.$router.push({
        name: "group",
        params: { groupNumber: groupNumber },
      });
    },
    handleEditGroup(group) {
      getGroupInfo(group.group_number)
        .then((res) => {
          this.group = res.entity;
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
      $("#editgroup").modal("show");
    },
    groupRefresh() {
      this.getGroups();
    },
    sortGroup(id) {
      if (id === 6) {
        return false;
      }
      let that = this;
      this.headers.map(function (item) {
        if (item.id === id) {
          item.showSort = true;
          item.sort = item.sort === "des" ? "asc" : "des";
          that.sortBy = item;
          return item;
        }
        item.showSort = false;
        item.sort = "des";
        return item;
      });
      this.sortGroupBy();
    },
    getGroups() {
      this.groups = [];
      this.loading = true;
      this.nothing = false;
      getGroups({})
        .then((res) => {
          if (res.status_code === 200) {
            this.loading = false;
            this.groups = res.entity.datas;
            if (res.entity.total > 0) {
              let requestNums = 0;
              res.entity.datas.map((group) => {
                if (group.group_member_identity != "user") {
                  if (group.group_pending_member_count > 0) {
                    requestNums += group.group_pending_member_count;
                  }
                }
              });
              this.$store.commit("setRequestNums", requestNums);
              this.sortGroupBy(true);
            } else {
              this.nothing = true;
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    sortGroupBy(waitTop = false) {
      this.groups.sort((x, y) => {
        let ind;
        if (waitTop) {
          ind = y.group_is_review.localeCompare(x.group_is_review);
        } else if (this.sortBy.field === "group_name") {
          ind = x[this.sortBy.field].localeCompare(y[this.sortBy.field]);
        } else {
          ind = x[this.sortBy.field] - y[this.sortBy.field];
        }
        ind = this.sortBy.sort === "asc" ? ind : -ind;
        return ind;
      });
    },
    groupCancel(group) {
      let text = group.group_is_review === "adopt" ? "解散" : "删除";
      this.$confirm({
        type: "confirm",
        content: `${text}群后，所有关于本群组的信息都将被删除且无法恢复，确定${text}【${group.group_name}】吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          groupCancel({
            groups_list: [group.group_number],
          })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });

                this.getGroups();
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    groupQuit(groupNumber) {
      this.$confirm({
        type: "confirm",
        content: "确定退出该群组吗？",
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          groupMember({
            group_number: groupNumber,
            action: "quit",
            members_list: [this.userInfo.user_number],
          })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.getGroups();
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    setTimeout(() => {
      for (let key in this.status) {
        this.status[key] = true;
      }
    }, 500);
  },
};
</script>

<style scoped>
.item-groupname .helpbox {
  position: relative;
  cursor: pointer;
}
.item-groupname .helpbox:hover .help {
  display: block;
}
.item-groupname .help {
  width: 322px;
  min-height: 34px;
  text-align: justify;
  border: #ddd solid 1px;
  background: #fff;
  padding: 10px;
  font-size: 12px;
  position: absolute;
  bottom: 30px;
  left: -12px;
  box-shadow: rgba(0, 0, 0, 0.2) 3px 0 10px;
  display: none;
  line-height: 1.5em;
  word-break: break-all;
}
.item-groupname .help:before {
  content: "";
  position: absolute;
  bottom: -12px;
  left: 10px;
  z-index: 2;
  border-width: 6px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}
.item-groupname .help:after {
  content: "";
  position: absolute;
  bottom: -16px;
  left: 9px;
  z-index: 1;
  border-width: 8px;
  border-style: solid;
  border-color: #ddd transparent transparent transparent;
}
</style>